import { createAsyncThunk } from "@reduxjs/toolkit";
import { userSignoutApi } from "../api/user-signout";
import { handleApiError, ApiError } from "../../../common/utils/api-utils";

export const userSignout = createAsyncThunk(
    'userProfile/signout',
    async (_data, thunkAPI) => {
      try {
        return await userSignoutApi();
      } catch (error) {
        console.error(error);
        if (error instanceof ApiError) {
          handleApiError(error);
        }
        return thunkAPI.rejectWithValue(error);
      }
    }
  );
  